<template>
  <v-card-text class="inserted-values px-9 pt-3">
    <v-row>
      <v-col cols="3" class="request-label">
        Typ odečtu
      </v-col>

      <v-col cols="9" class="request-value">
        {{ individualReading.type.localizedText || missingValueString}}
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="3" class="request-label">
        Datum odečtu
      </v-col>

      <v-col cols="9" class="request-value">
        {{ dateFormatting(individualReading.date) || missingValueString }}
      </v-col>
    </v-row>

    <v-row v-if="individualReading.highTariff">
      <v-col cols="3" class="request-label">
        Hodnota (VT)
      </v-col>

      <v-col cols="9" class="request-value">
        {{ individualReading.highTariff || missingValueString }}
        kWh
      </v-col>
    </v-row>

    <v-row v-if="individualReading.lowTariff">
      <v-col cols="3" class="request-label">
        Hodnota (NT)
      </v-col>

      <v-col cols="9" class="request-value">
        {{ individualReading.lowTariff || missingValueString }}
        kWh
      </v-col>
    </v-row>
  </v-card-text>
</template>

<script>
export default {
  name: 'IndividualReadingInsertedValues',
  props: {
    individualReading: {
      type: Object,
      required: false,
    },
  },
};
</script>
